if (!customElements.get('variant-collapsible-content')) {
  class VariantCollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    onVariantChange(event) {
      if (event.data.sectionId !== this.dataset.sectionId) return;
      const updated = event.data.html.querySelector(
        `variant-collapsible-content[data-block-id="${this.dataset.blockId}"]`
      );
      if (!updated) return;
      this.innerHTML = updated.innerHTML;
      this.hidden = this.innerHTML.trim() === '';
    }
  }

  customElements.define('variant-collapsible-content', VariantCollapsibleContent);
}
